<template>
  <div>
    <a-card
      :bordered="false"
      class="header-solid h-full mb-40"
      :bodyStyle="{ paddingTop: '12px' }"
    >
      <template #title>
        <a-row>
          <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="20">
            <h6>Extra & Part-time</h6>
            <p class="mb-10">
              You are only required to upload the log record for courses under
              extra teaching payment or if you are a part-time instructor
            </p>
          </a-col>
          <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="4">
            <a-button @click="toCreateRecord" block type="primary">
              Create Teaching record
            </a-button>
          </a-col>
        </a-row>
      </template>
      <!-- table - records list -->
      <a-table
        :columns="columns"
        :data-source="dataListTeachingLog"
        :pagination="false"
        :loading="loading"
        bordered
        class="mb-5"
      >
        <template slot="period" slot-scope="text, record">
          {{ record.around_show.period }}
        </template>
        <template slot="status" slot-scope="text, record">
          <a-tag
            :color="
              record.status === 'wait'
                ? '#ffc71e'
                : record.status === 'Approved'
                ? '#87d068'
                : ''
            "
          >
            {{ record.status }}
          </a-tag>
        </template>
        <template slot="file" slot-scope="text, record">
          <a target="_blank" :href="record.upload_file">Link</a>
        </template>
        <template slot="action" slot-scope="text, record">
          <div v-if="record.status === 'wait'">
            <a @click="showDeleteConfirm(record)"
              ><a-icon
                :style="{ color: 'red', fontSize: '20px' }"
                type="delete"
                theme="filled"
            /></a>
          </div>
        </template>
        <template slot="footer" slot-scope="currentPageData"> </template>
      </a-table>
    </a-card>
    <a-modal
      v-model="visibleRecord"
      title="Confirm Delete !"
      ok-text="Delete"
      ok-type="danger"
      cancel-text="Close"
      @ok="delRecords(objData.id)"
    >
      <p class="mb-10"><strong>Are you sure delete this teaching log ?</strong></p>
      <div v-if="visibleRecord">
        
        <p class="mt-0 mb-0">
          {{ objData.course }} {{ objData.term }} sec.{{ objData.section }}
        </p>
        <p class="mt-0 mb-0">Period : {{ objData.around_show.period }}</p>
      </div>
    </a-modal>
  </div>
</template>
<script>
const columns = [
  {
    title: "Course",
    dataIndex: "course",
    scopedSlots: { customRender: "course" },
  },
  {
    sort: true,
    title: "Term",
    dataIndex: "term",
    className: "text-center",
    scopedSlots: { customRender: "term" },
  },
  {
    title: "Section",
    dataIndex: "section",
    className: "text-center",
    scopedSlots: { customRender: "section" },
  },
  {
    title: "Teaching period",
    dataIndex: "period",
    scopedSlots: { customRender: "period" },
  },
  {
    title: "Status",
    dataIndex: "status",
    className: "text-center",
    scopedSlots: { customRender: "status" },
  },
  {
    title: "File",
    dataIndex: "file",
    scopedSlots: { customRender: "file" },
  },
  {
    title: "Action",
    dataIndex: "action",
    className: "text-center",
    scopedSlots: { customRender: "action" },
  },
];
const dataListTeachingLog = [];
export default {
  data() {
    return {
      dataListTeachingLog,
      columns,
      pagination: {},
      objData: {},
      visibleRecord: false,
      loading: false,
    };
  },
  mounted() {
    this.getListTeachingLog();
  },
  methods: {
    toCreateRecord() {
      this.$router
        .push({
          path: "/teaching/form",
        })
        .catch((err) => {});
    },
    async getListTeachingLog() {
      this.loading = true;
      this.dataListTeachingLog = [];
      try {
        const res = await this.$http.get("/teaching/note/me/");
        if (res.status === 200) {
          this.dataListTeachingLog = res.data.map((item) => ({
            ...item,
          }));
          this.dataListTeachingLog.sort((a, b) => {
            return b.id - a.id;
          });
          this.loading = false;
        } else {
          const error = new Error('Request Failed');
          error.res = res;
          error.response = res;
          throw error;
        }
      } catch (error) {
        this.loading = false;
        this.dataListTeachingLog = [];
        this.$notification.open({
          style: {
            backgroundColor: "#ff1919",
            color: "#ffffff",
          },
          message: function (h) {
            return h("div", [
              h("strong", { class: "" }, `Error ${error.response.status}`),
            ]);
          },
          description: `Problem issue connect api : /teaching/note/me/`,
        });
      }
    },
    showDeleteConfirm(obj) {
      this.objData = { ...obj };
      this.visibleRecord = true;
    },
    async delRecords(id) {
      try {
        const res = await this.$http.delete(`/teaching/note/${id}/remove/`);
        if (res.status === 200) {
          this.visibleRecord = false
          this.objData = {}
          this.getListTeachingLog();
        } else {
          const error = new Error('Request Failed');
          error.res = res;
          error.response = res;
          throw error;
        }
      } catch (error) {
        this.$notification.open({
          style: {
            backgroundColor: "#ff1919",
            color: "#ffffff",
          },
          message: function (h) {
            return h("div", [
              h("strong", { class: "" }, `Error ${error.response.status}`),
            ]);
          },
          description: `Problem issue connect api : /teaching/note/${id}/remove/`,
        });
      }
    },
  },
};
</script>